<template>
  <div v-if="show">
    <div class="logout-dialog-background" @click="emitClose"></div>
    <div class="logout-dialog">
      <div class="logout-dialog-button" @click="performLogout">
        <div class="dialog-button-text">
          Abmelden und <br />zurück zum Piratenprofil
        </div>
      </div>
      <div class="logout-dialog-button-divider"></div>
      <div class="logout-dialog-button" @click="goBack">
        <div class="dialog-button-text">
          <b>Ohne</b> Abmelden <br />zurück zum Piratenprofil
        </div>
      </div>
      <button
        class="btn abort-btn"
        style="margin-top: 20px;"
        @click="emitClose"
      >
        Abbrechen
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "LogoutDialog",
  props: {
    show: { type: Boolean, default: false }
  },
  methods: {
    ...mapActions("authentication", ["logout"]),
    async performLogout() {
      try {
        await this.logout();
        this.goBack();
      } catch (e) {
        this.goBack();
      }
    },
    emitClose() {
      this.$emit("close");
    },
    goBack() {
      window.location = "https://eurothermen.at/login/";
    }
  }
};
</script>

<style scoped>
.logout-dialog-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9997;
  background-color: rgba(0, 0, 0, 0.6);
}

.logout-dialog {
  position: fixed;
  background: linear-gradient(to right, #0a345f, #0178b7);
  padding: 20px;
  top: 50%;
  left: 50%;
  width: 400px;
  transform: translate(-50%, -50%);
  z-index: 9998;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logout-dialog-button {
  height: 100px;
  background-color: #00a7ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.logout-dialog-button:hover {
  background-color: #0178b7;
}

.logout-dialog-button-divider {
  border-top: 1px solid rgba(0, 0, 0, 0.4);
}

.dialog-button-text {
  user-select: none;
  font-size: 1.1rem;
}

@media (max-width: 576px) {
  .logout-dialog {
    width: 100%;
  }
}
</style>
